import React, { useState, useContext, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import ProviderCard from './building_blocks/ProviderCard';
import PageHeader from './building_blocks/PageHeader';
import SearchField from './SearchField';
import { providersPathTo } from '../utils/Api';
import { originParamsFromUser } from '../utils/providerListParams';
import { UserContext } from '../contexts/UserContext';
import { SearchContext } from '../contexts/SearchContext';
import { useNavigate } from 'react-router-dom';

const Search = () => {
  const [loading, setLoading] = useState(false);
  const { currentUser } = useContext(UserContext);
  const { searchResults, setSearchResults, searchTags, setSearchTags, setFromSearch } = useContext(SearchContext);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Busca - TudoPets.app';
  }, []);

  const handleSearchValueChange = (value) => {
    setSearchTags(value);
    if (value.length === 0) {
      setSearchResults([]);
      return;
    }
    setLoading(true);
    const tags = value.map(tag => tag.name).join(',')
    const params = {
      t: tags,
      ...originParamsFromUser(currentUser),
    };
    providersPathTo.list({ params }).then((result) => {
      setLoading(false);
      setSearchResults(result.data);
    });
  };

  const handleCardClick = (providerId) => {
    setFromSearch(true)
    navigate(`/provider/${providerId}`);
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      <PageHeader title="Busca" />

      <SearchField onChange={handleSearchValueChange} value={searchTags} />

      {loading ? (
        <Typography>Carregando...</Typography>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, alignSelf: 'stretch' }}>
          {searchResults.map((provider) => (
            <ProviderCard key={provider.id} provider={provider} showProducts={true} categories={false} onCardClick={() => handleCardClick(provider.id)} />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default Search;
